import { useEffect, useState } from 'react';

import getConfig from '../../util/config';
import useConsentManager from '../../hooks/useConsentManager';

const useNonEssentialScriptLoader = () => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const { facebook = {}, google = {}, crazyEgg = {} } = getConfig();
  const { hasNonEssentialConsent } = useConsentManager();

  const getScriptNodes = () => {
    const nodes = [];

    // Facebook Meta Pixel (script)
    if (facebook.metaPixelId) {
      const facebookScript = document.createElement('script');
      facebookScript.id = 'script-loader-facebook';
      facebookScript.textContent = `
      !function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${facebook.metaPixelId}');
    `;
      nodes.push({ id: facebookScript.id, script: facebookScript });
    }

    // Google Tag Manager (noscript)
    if (google.tagManagerId) {
      const noscript = document.createElement('noscript');
      noscript.id = 'script-loader-tag-manager';
      const iframe = document.createElement('iframe');
      iframe.id = 'tag-manager';
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${google.tagManagerId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      nodes.push({ id: noscript.id, script: noscript, prepend: true });
    }

    // Google gtag
    if (google.gtagId) {
      const gtagScript = document.createElement('script');
      gtagScript.id = 'script-loader-gtag-1';
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${google.gtagId}`;
      nodes.push({ id: gtagScript.id, script: gtagScript });

      const gtagFunctionScript = document.createElement('script');
      gtagFunctionScript.id = 'script-loader-gtag-2';
      gtagFunctionScript.textContent =
        'function gtag(){dataLayer.push(arguments);}';
      nodes.push({ id: gtagFunctionScript.id, script: gtagFunctionScript });
    }

    // CrazyEgg
    if (crazyEgg.apiKey) {
      const crazyEggScript = document.createElement('script');
      crazyEggScript.id = 'script-loader-crazy-egg';
      crazyEggScript.type = 'text/javascript';
      crazyEggScript.src =
        'https://script.crazyegg.com/pages/scripts/0120/4978.js';
      crazyEggScript.async = true;
      nodes.push({ id: crazyEggScript.id, script: crazyEggScript });
    }

    return nodes;
  };

  useEffect(() => {
    // Only load scripts if we have consent
    if (scriptsLoaded || !hasNonEssentialConsent) {
      return;
    }

    const scriptsNodes = getScriptNodes();
    scriptsNodes.forEach(({ id, script, prepend }) => {
      if (!document.getElementById(id)) {
        if (prepend) {
          document.body.prepend(script);
        } else {
          document.body.appendChild(script);
        }
      }
    });
    setScriptsLoaded(true);
  }, [hasNonEssentialConsent]);
};

export default useNonEssentialScriptLoader;
